import styled from 'styled-components';
import { WarningBanner } from 'ui/banner';
import { Toggletip } from 'ui/tooltip';
import { spacing } from 'ui/theme';

export const StyledLabel = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.half};
`;

export const Actions = styled.div`
  margin-top: 2rem;
`;

export const SplitInputWrapper = styled.div`
  padding-left: ${spacing.double};
`;

export const StyledBanner = styled(WarningBanner)`
  margin-top: ${spacing.base};
`;

export const StyledToggleTip = styled(Toggletip)`
  display: inline-flex;
`;
